<template>
    <component :is="elementType" :class="[alignTextClass, classes.title]">
        {{ title }}
    </component>
</template>

<script setup lang="ts">
import {computed} from 'vue';

interface Classes {
    title?: string;
}

interface Props {
    title: string,
    alignText?: string,
    classes?: Classes,
    elementType?: string,
}

const alignTextClass = computed(() => {
    if (props.alignText === 'center') {
        return 'text-center';
    } else {
        return 'text-start';
    }
})

const props = withDefaults(defineProps<Props>(), {
    title: 'Default Subtitle',
    alignText: 'left',
    elementType: 'h5',
    classes: () => ({
        title: '',
    }),
});
</script>